import React, { FC, PropsWithChildren } from 'react';

import { ChatBubble } from '../../../../integrations/roqChat/ChatBubble';
import { NavItem } from '../types';

import * as Styled from './styled';

type Props = PropsWithChildren<{
  item: NavItem;
}>;

/**
 * Wrapper around rail link, that shows notifications count if any
 *
 * @param props          Props passed to the component
 * @param props.children Children passed to the component
 * @param props.item     Item object for rail navigation
 * @returns              The component itself
 */
const RailNotificationBadge: FC<Props> = ({ children, item }) => {
  const { id, notificationsCount } = item;

  if (id === 'chat') {
    return <Styled.Badge component={ChatBubble} />;
  }

  if (notificationsCount === undefined || notificationsCount === 0) {
    return children;
  }

  return <Styled.Badge badgeContent={notificationsCount} />;
};

export default RailNotificationBadge;
